import React from "react";
import { themeGet } from "styled-system";

import styled from "styled-components";
import LikertScale from "likert-react";
import { SmallContainer } from "../Grid";
import TextF8 from "../TextF8";
import TextF6 from "../TextF6";
import Box from "../Box";
import { StyledSubmitButton } from "../StyledButton";
import {
  fetchPeerReviewOptions,
  reportSpam
} from "../../services/quiznator";
import { config } from "../../state/course-config";
import { injectIntl, FormattedMessage } from "react-intl";

import PeerReviewOption from "./peer-review-option";
import _get from "lodash/get";

import "likert-react/dist/main.css";

const SubmitButton = styled(StyledSubmitButton)``;
const AnotherButton = styled.span`
  max-width: 222px;
  color: #d36bd3;
  text-decoration: underline;
  :hover {
    text-decoration: none;
    cursor: pointer;
  }
`;

const LikertWrapper = styled.div`
  padding: 0;
  .likert-react_src-___styles__container-striped {
    padding: 1rem;
    flex-direction: column;
    font-family: ${themeGet("fonts.TTNormsProRegular")};
    .likert-react_src-review-scale-___styles__scale {
      margin: 0.5rem 0 0 0.3rem;
    }
    .likert-react_src-___styles__question {
      max-width: 100%;
    }
    @media screen and (min-width: 32em) {
      .likert-react_src-___styles__question {
        max-width: 60%;
      }
      .likert-react_src-review-scale-___styles__scale {
        margin: 0 0 0 0.3rem;
      }
      flex-direction: row;
    }
  }
  .likert-react_src-___styles__container-striped:nth-child(odd) {
    background: rgba(255, 255, 255, 0.5);
  }
  .likert-react_src-___styles__container-striped:nth-child(even) {
    background: rgba(255, 255, 255, 0.75);
  }
`;

const Warning = styled(TextF8)`
  position: relative;
  padding: 1em 2em;
  color: rgba(255, 255, 255);
  background-color: rgba(128, 64, 200, 0.75);
  border-radius: 8px;
  border: 2px solid transparent;
`;

const initialState = {
  options: undefined,
  selectedOptionId: undefined,
  reviewAnswers: {},
  done: false
};

class PeerReview extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.state.nowGivenReviews = 0;

    this.peerReviewQuestions = [
      {
        question: this.props.intl.formatMessage({ id: "peerreview.question1" })
      },
      {
        question: this.props.intl.formatMessage({ id: "peerreview.question2" })
      },
      {
        question: this.props.intl.formatMessage({ id: "peerreview.question3" })
      },
      {
        question: this.props.intl.formatMessage({ id: "peerreview.question4" })
      }
    ];
  }

  componentDidMount() {
    if (this.getPeerReviewCount() >= config.MINIMUM_PEER_REVIEWS_GIVEN) {
      this.setState({ done: true });
    } else {
      this.fetchData();
    }
  }

  fetchData() {
    const id = this.props.quiz._id;
    fetchPeerReviewOptions(id)
      .then(options => {
        this.setState({
          options: options.peerReviews
        });
      })
      .catch(err => {
        throw new Error(err);
      });
  }

  onComplete() {
    if (this.getPeerReviewCount() >= config.MINIMUM_PEER_REVIEWS_GIVEN) {
      // was: +1?
      this.setState({ done: true });
    } else {
      this.setState(
        {
          ...initialState,
          ...{ nowGivenReviews: this.getPeerReviewCount() + 1 }
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  getPeerReviewCount() {
    return _get(this.props, "peerReviewsGiven", []).length;
  }

  render() {
    if (this.state.done) {
      return (
        <Box bg="#EBE9EF" py={5}>
          <SmallContainer>
            <Box>
              <TextF6 m={0}>
                <FormattedMessage id="peerreview.thankYou" />
              </TextF6>
              <TextF6 m={0}>
                <FormattedMessage id="peerreview.giveMoreReviews" />{" "}
                <AnotherButton
                  onClick={() => {
                    this.setState({ ...initialState }, () => {
                      this.fetchData();
                    });
                  }}
                >
                  <FormattedMessage id="peerreview.giveMoreReviewsButton" />
                </AnotherButton>
              </TextF6>
            </Box>
          </SmallContainer>
        </Box>
      );
    }
    if (!this.state.options) {
      return (
        <Box bg="#EBE9EF" py={5}>
          <SmallContainer>
            <TextF6 m={0}>
              <FormattedMessage id="globals.loading" />
            </TextF6>
          </SmallContainer>
        </Box>
      );
    }
    if (this.state.options.length < 2) {
      return (
        <Box bg="#EBE9EF" py={5}>
          <SmallContainer>
            <TextF6 mt={0}>
              <FormattedMessage id="peerreview.notEnoughAnswers" />
            </TextF6>
          </SmallContainer>
        </Box>
      );
    }

    return (
      <Box bg="#EBE9EF" py={5}>
        <SmallContainer>
          <TextF6>
            {this.getPeerReviewCount() + 1}/{config.MINIMUM_PEER_REVIEWS_GIVEN}
          </TextF6>
          <TextF6 mt={0}>
            <FormattedMessage id="peerreview.selectAnswerMessage" />
          </TextF6>
          {this.getPeerReviewCount() + 1 < config.MINIMUM_PEER_REVIEWS_GIVEN ? (
            <Warning>
              <FormattedMessage id="peerreview.minimumPeerReviewWarning" />
            </Warning>
          ) : null}
          <Box mt={5}>
            {this.state.options.map(option => (
              <PeerReviewOption
                option={option}
                key={option._id}
                selected={this.state.selectedOptionId === option._id}
                onSelected={() => {
                  this.onOptionSelected(option._id);
                }}
                onReportSpam={() => {
                  this.reportSpam(option._id);
                }}
              />
            ))}
          </Box>
          {!this.state.selectedOptionId ? (
            ""
          ) : (
            <div>
              <LikertWrapper>
                <LikertScale
                  reviews={this.peerReviewQuestions}
                  separatorType="striped"
                  highlightColor="#19CA94"
                  onClick={this.handleLikertChange.bind(this)}
                />
              </LikertWrapper>
              <Box
                mt={3}
                display="flex"
                justifyContent="flex-end"
                align-items="top"
              >
                <SubmitButton
                  disabled={
                    Object.keys(this.state.reviewAnswers).length !==
                    this.peerReviewQuestions.length
                  }
                  onClick={() => {
                    //submitPeerReview(
                    this.props
                      .onSubmitPeerReview({
                        selectedOptionId: this.state.selectedOptionId,
                        reviewAnswers: this.state.reviewAnswers,
                        options: this.state.options,
                        peerreviewid: this.props.peerreviewid,
                        quizId: this.props.quiz._id
                      })
                      .then(data => {
                        this.onComplete();
                        //this.props.receivePeerReview(data)
                      });
                  }}
                >
                  Submit
                </SubmitButton>
              </Box>
            </div>
          )}
        </SmallContainer>
      </Box>
    );
  }

  handleLikertChange(question, answer) {
    this.setState(prev => {
      return {
        reviewAnswers: Object.assign({}, prev.reviewAnswers, {
          [question]: answer
        })
      };
    });
  }

  onOptionSelected(id) {
    this.setState({
      selectedOptionId: id
    });
  }

  reportSpam(id) {
    reportSpam(id)
      .then(() => {
        this.setState({
          ...initialState,
          nowGivenReviews: this.state.nowGivenReviews
        });
        this.fetchData();
      })
      .catch(err => {
        console.error("error: ", err);

        this.setState({
          ...initialState,
          nowGivenReviews: this.state.nowGivenReviews
        });
        this.fetchData();
      });
  }
}

export default injectIntl(PeerReview);
